module.exports = ".card-dashboard .card-body {\n  height: 200px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/lobby/lobby.component.scss
// module id = ./src/app/shared/lobby/lobby.component.scss
// module chunks = main